/**
 * Copies text with the async Clipboard API. Returns false when it is unavailable (plain http,
 * old browser, permission denied) so the caller can select the text and ask for Ctrl+C.
 */
export async function copyText(text: string): Promise<boolean> {
  try {
    if (!navigator.clipboard?.writeText) return false;
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    return false;
  }
}
